import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarModeloTarefaPayload, atualizarModeloTarefaPayload } from '../../interfaces/modelosTarefas'


export function novaTarefaModelo (payload: cadastrarModeloTarefaPayload) {
    return BASEURLGESTTOR.post('/tarefasmodelos', payload)
} 

export function listarTarefasModelos (idModeloProcesso: string) {
    return BASEURLGESTTOR.get(`/tarefasmodelos?idModeloProcesso=${idModeloProcesso}`)
}

export function atualizarTarefaModelo (idTarefaModelo: string, payload: atualizarModeloTarefaPayload) {
    return BASEURLGESTTOR.patch(`/tarefasmodelos?idTarefaModelo=${idTarefaModelo}`, payload)
}

export function deletarTarefaModelo (idTarefa: string) {
    return BASEURLGESTTOR.delete(`/tarefasmodelos?idTarefaModelo=${idTarefa}`)
}

